"use client";
import { useGetBanks } from "@/hooks/main-hook";
import { BankProps } from "@/types/main-types";
import { trunkPropertyDesc } from "@/utils/trunck";
import { useLocale } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import Paginate from "../paginate/paginate";

export default function MainBanks() {
  const [currentPage, setCurrentPage] = useState(1);
  const locale = useLocale();

  const { data, isLoading } = useGetBanks({ page: currentPage, limit: 4 });

  const banks = data?.banks || [];

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {isLoading
          ? [1, 2, 3, 4].map((e) => <SkeltonLoader key={e} />)
          : banks?.map((e: BankProps) => (
              <div key={e.id} className="border border-gray-300 rounded-xl p-3">
                <div className="relative min-h-27.5 w-full">
                  <Image
                    src={e.image}
                    alt={e.name_en}
                    width={150}
                    height={150}
                    className="h-auto object-contain mx-auto"
                  />
                </div>

                <div className="mt-5 space-y-2">
                  <h3 className="text-lg font-bold text-dark">
                    {locale === "ar" ? e.name_ar : e.name_en}
                  </h3>
                  <p className="text-sm leading-6 text-gray-500">
                    {trunkPropertyDesc(
                      locale === "ar" ? e.description_ar : e.description_en,
                      100
                    )}
                  </p>
                  <Link
                    href={`/banks/${e.slug}`}
                    className="bg-main text-white py-2 px-5 rounded-xl my-5 block w-fit"
                    aria-label={locale === "ar" ? "اقرأ المزيد" : "View More"}
                  >
                    {locale === "ar" ? " اقرأ المزيد" : "View More"}
                  </Link>
                </div>
              </div>
            ))}
      </div>

      {data?.paginate?.totalPages > 1 && (
        <Paginate
          currentPage={currentPage}
          totalPages={data?.paginate?.totalPages || 0}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
}

const SkeltonLoader = () => {
  return (
    <div className="border border-gray-300 rounded-xl p-3 animate-pulse">
      <div className="relative min-h-27.5 w-full flex items-center justify-center">
        <div className="w-24 h-24 bg-gray-300 rounded-md"></div>
      </div>

      <div className="mt-5 space-y-3">
        <div className="h-5 bg-gray-300 rounded w-3/4"></div>
        <div className="h-4 bg-gray-300 rounded w-full"></div>
        <div className="h-4 bg-gray-300 rounded w-5/6"></div>

        <div className="h-9 bg-gray-300 rounded-xl w-28 mt-4"></div>
      </div>
    </div>
  );
};
